<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="columns box">
            <div class="column is-5">
                <div class="columns">
                    <div class="column is-6">
                        <b-field>
                            <b-input placeholder="Procurar por descrição"
                                    v-model="procurar"
                                    icon="magnify"
                                    @input="loadAsyncData"></b-input>
                        </b-field>
                    </div>
                    <div class="column is-6">
                        <b-datepicker editable placeholder="Selecione o período"
                            v-model="datas"
                            position="is-bottom-right"
                            @input="loadAsyncData"
                            range>
                        </b-datepicker>           
                    </div>     
                </div> 
            </div> 
            <div class="column">
                <div class="columns">
                    <div class="column is-12">
                        <div class="is-flex is-justified-between">
                            <router-link
                                :to="{ name: 'amostralote' }"
                                class="button is-primary"
                                >
                                Incluir
                            </router-link>
                        </div>  
                    </div>  
                </div>               
            </div>           
            <div class="column is-2">
                <div class="columns">
                    <div class="column is-12">
                        <form @submit.prevent="abrirCadastroInput">
                            <b-field>
                                <b-input placeholder="Código"
                                        v-model="id"
                                        type="text"
                                        icon-right="edit"
                                        icon-right-clickable
                                        @icon-right-click="abrirCadastroInput">
                                </b-input>
                            </b-field>
                        </form>
                    </div>  
                </div>
            </div>
        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                 paginated
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                 aria-next-label="Próxima página"
                 aria-previous-label="Página anterior"
                 aria-page-label="Página"
                 aria-current-label="Página atual"
                 backend-sorting
                 :default-sort-direction="defaultOrdenar"
                 :default-sort="[ordenarPor, ordenar]"
                 sort-icon-size="is-small"
                 @sort="onSort">

            <template slot-scope="props" @click="abrirCadastro(props.row.id)">
                <b-table-column field="id" label="Id" sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column field="Descricao" label="Descrição" sortable>
                    {{ props.row.descricao }}
                </b-table-column>
                
                <b-table-column field="ConvenioNome" label="Convênio" sortable>
                    {{ props.row.convenioNome }}
                </b-table-column>
                
                <b-table-column field="Envio" label="Envio">
                    {{ props.row.envio | data }}
                </b-table-column>
                
                <b-table-column field="Recebimento" label="Recebimento">
                    {{ props.row.recebimento | data }}
                </b-table-column>

                <b-table-column custom-key="actions" numeric>
                    <router-link :to="{ name: 'amostralote', params: { id: props.row.id }}" class="button is-small is-primary" title="Editar">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                </b-table-column>
            </template>
        </b-table>
    </section>
</template>

<script>
    import { mapGetters } from 'vuex'
    import titlebar from '@/components/titlebar.vue'

    export default {
        data() {
            return {
                model: [],
                total: 0,
                loading: false,
                procurar: this.$route.query.procurar ?? '',
                ordenarPor: 'Id',
                ordenar: 'desc',
                defaultOrdenar: 'desc',
                page: 1,
                perPage: 20,
                selecionado: null,
                id: null,
                datas: [
                    this.$moment().subtract(30, 'days').toDate(),
                    this.$moment().toDate()
                ],
            }
        },
        components: {
            titlebar
        },
        computed: {
            titleStack() {
                return [
                    'Atendimento',
                    'Lote de Amostras',
                    'Listar'
                ]
            },
            ...mapGetters([
                'isInRole'
            ])
        },
        methods: {
           loadAsyncData() {
                const params = [
                    `procurar=${this.procurar}`,
                    `ordem=${this.ordenarPor}.${this.ordenar}`,
                    `page=${this.page}`,
                    `perPage=${this.perPage}`,
                    `dataInicial=${this.$moment(this.datas[0]).format()}`,
                    `dataFinal=${this.$moment(this.datas[1]).format()}`
                ].join('&')

                this.loading = true
                this.$http.get(`/api/atendimento/amostralotelistar?${params}`)
                    .then(({ data }) => {
                        this.model = data;
                        if (data.lista.length == 0 && this.page > 1) {
                            this.page = 1
                            this.loadAsyncData()
                        }
                        this.total = this.perPage * data.pageCount
                        this.loading = false
                        this.$router.replace({query: {procurar: this.procurar, page: this.page }})
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },
            abrirCadastro() {
                this.$router.push({ path: `/atendimento/amostralote/${this.selecionado.id}` })
            },
            abrirCadastroInput() {
                this.$router.push({ path: `/atendimento/amostralote/${this.id}` })
            },
        },
        mounted() {
            this.loadAsyncData()
        }
    }
</script>